import { useCallback, useMemo, useEffect } from 'react';
import classNames from 'classnames';
import { ErrorSchema, Field } from '@rjsf/utils';
import { MarkdownContent } from '../markdown-content';
import MonacoEditor, { useMonaco } from '@monaco-editor/react';

import draculaTheme from './source-code-field-editor-theme.json';

export const SourceCodeField: Field = (props) => {
  const {
    idSchema,
    schema: { title, description },
    uiSchema: { 'ui:options': uiOptions = {} } = {},
    formData,
    readonly,
    disabled,
    onChange,
    ...restProps
  } = props;
  const {
    language = 'html' as any,
    height = '20vh' as any,
    width = '100%' as any,
    theme = 'dracula' as any,
    ...restUiOptions
  } = uiOptions;

  const monaco = useMonaco();

  useEffect(() => {
    if (monaco) {
      // @ts-ignore
      monaco.editor.defineTheme('dracula', draculaTheme);
    }
  });
  const handleOnChange = useCallback(
    (value: string | undefined) => {
      if (value === undefined) return;
      if (language === 'json') {
        try {
          onChange(JSON.parse(value));
        } catch {
          // @ts-ignore
          onChange(null, {
            __errors: ['Invalid JSON'],
          } as ErrorSchema<string>);
        }
      } else {
        onChange(value);
      }
    },
    [onChange]
  );
  const defaultValue = useMemo(() => {
    if (language === 'json') {
      return JSON.stringify(formData, null, 2);
    }
    return formData;
  }, [formData]);
  return (
    <div className="form-group">
      {title && (
        <label className="form-label" htmlFor={idSchema.$id}>
          {title}
        </label>
      )}
      <div className={'wrapper'}>
        {/* @ts-ignore */}
        <MonacoEditor
          id={idSchema.$id}
          className={classNames(['form-control', 'source-code'])}
          theme={theme}
          width={width}
          height={height}
          defaultLanguage={language}
          defaultValue={defaultValue}
          onChange={handleOnChange}
          options={{
            fontFamily: 'JetBrains Mono',
            fontLigatures: true,
            readOnly: disabled || readonly,
            tabSize: 2,
            minimap: {
              enabled: false,
            },
            ...restUiOptions,
          }}
          {...restProps}
        />
      </div>
      <small className="text-muted form-text">
        <MarkdownContent>{description as string}</MarkdownContent>
      </small>
    </div>
  );
};
